import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { ProjectDraft } from './project.model';
export interface ProjectPerson {
    id: string;
    firstName: string;
    lastName: string;
}
export interface ProjectSettings {
    rows: ProjectDraft[];
    hiddenColumns: string[];
}
export interface ProjectDataSource {
    read(): ProjectSettings;
    save(value: ProjectSettings): void;
    people(): Observable<ProjectPerson[]>;
}
export const PROJECT_DATA = new InjectionToken<ProjectDataSource>('ProjectDataSource');
